import React from 'react';
import { motion } from 'framer-motion';
/**
 * Subtle, professional light sweep that travels across a CTA button.
 * Purely decorative: pointer-events-none and aria-hidden so it never
 * interferes with clicks or screen readers. Designed to sit inside a
 * button that is `relative overflow-hidden`, behind the label (z-0).
 */
export function CtaShimmer() {
  return <motion.span aria-hidden="true" initial={{
    x: '-160%'
  }} animate={{
    x: '260%'
  }} transition={{
    duration: 1.1,
    repeat: Infinity,
    repeatDelay: 2.6,
    ease: 'easeInOut'
  }} className="pointer-events-none absolute inset-y-0 left-0 z-0 w-1/3 -skew-x-12 bg-gradient-to-r from-transparent via-white/45 to-transparent" data-id="element-63" />;
}